(() => {
  'use strict';

  const modalSelector = '#fmmPrivacyModalV61';
  const choiceSelector = '[data-fmm-newsletter-choice]';
  let accountState = null;
  let preferenceLoaded = false;

  function addChoice(modal) {
    if (!modal || modal.querySelector(choiceSelector)) return;
    const footer = modal.querySelector('footer');
    if (!footer) return;
    const label = document.createElement('label');
    label.className = 'fmm-newsletter-choice';
    label.dataset.fmmNewsletterChoice = 'true';
    label.hidden = true;
    label.innerHTML = '<input type="checkbox" checked> <span><strong>Send me the weekly FreeMinecraftMods roundup</strong><small>Get new projects, updated listings, and safe-download guidance by email. You can change this anytime in account settings.</small></span>';
    footer.prepend(label);
    loadPreference(label);
  }

  async function loadPreference(label) {
    if (preferenceLoaded) return;
    preferenceLoaded = true;
    try {
      const authResponse = await fetch('/api/auth/me', { headers: { accept: 'application/json' } });
      const auth = authResponse.ok ? await authResponse.json() : {};
      accountState = auth.user || null;
      if (!accountState) return;
      const preferenceResponse = await fetch('/api/newsletter/preference', { headers: { accept: 'application/json' } });
      const preference = preferenceResponse.ok ? await preferenceResponse.json() : {};
      const checkbox = label.querySelector('input');
      if (checkbox) checkbox.checked = preference.configured ? preference.opted_in !== false : true;
      label.hidden = false;
    } catch {
      accountState = null;
    }
  }

  function savePreference() {
    const label = document.querySelector(`${modalSelector} ${choiceSelector}`);
    if (!label || !accountState) return;
    const checkbox = label.querySelector('input');
    fetch('/api/newsletter/preference', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ opted_in: Boolean(checkbox?.checked) }),
      keepalive: true
    }).catch(() => {});
  }

  const observer = new MutationObserver(() => {
    const modal = document.querySelector(modalSelector);
    if (modal?.classList.contains('open')) addChoice(modal);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('fmm-newsletter-save', savePreference);
  window.addEventListener('click', event => {
    if (event.target.closest?.(`${modalSelector} [data-fmm61-consent]`)) savePreference();
  }, true);
})();
